import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "bootstrap/dist/css/bootstrap.css";
import "./Styles.css";

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js